import React from 'react';
import { useNavigate } from 'react-router-dom';
import SideMenu from './SideMenu';
import logo from './assets/icons/logo-no-background.png';
import './LegalPages.css';

function LegalPageLayout({ title, children }) {
	const navigate = useNavigate();

	return (
		<div className="legal-page">
			<div className="header-container">
				<div className="header-left">
					<SideMenu />
				</div>
				<div className="logo-box" onClick={() => navigate('/')}>
					<img src={logo} alt="Movie Quotes Guesser Logo" className="logo" />
					<h3 className="logo-text">Movie Quotes Guesser</h3>
				</div>
				<div className="header-right legal-header-right">
					<button type="button" className="legal-home-button" onClick={() => navigate('/')}>
						Home
					</button>
				</div>
			</div>
			<main className="legal-content">
				<h1 className="legal-title">{title}</h1>
				<div className="legal-body">{children}</div>
			</main>
			<footer className="legal-footer">
				<span>© {new Date().getFullYear()} Movie Quotes Guesser</span>
			</footer>
		</div>
	);
}

export default LegalPageLayout;
